import { Box, Skeleton, Theme, useMediaQuery } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'src/store'
import { fetchOperationUnit } from 'src/store/slices/operationUnitSlice'
import DashboardCardPlacer from 'src/views/dashboard/dashboard-card-placer'
import { DashboardNav } from 'src/views/dashboard/dashboard-nav'
import DashboardNoLand from 'src/views/dashboard/dashboard-no-land'

const Home = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { operationUnitsAll, loading: loadingOperationUnitsAll } = useSelector(
    (state: RootState) => state.operationUnit
  )
  const { rainDashboarCardInformation } = useSelector((state: RootState) => state.rain)
  const { cardInfo } = useSelector((state: RootState) => state.rodeo)
  const { land } = useSelector((state: RootState) => state.land)
  const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

 useEffect(() => {
  dispatch(fetchOperationUnit())
 }, [dispatch])

  return (
     <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: hidden ? 15 : 0
      }}
    >
      <DashboardNav operationUnits={operationUnitsAll} land={land} />

      {loadingOperationUnitsAll ? (
        <Box sx={{ mt: 2, width: '100%', display: 'flex', justifyContent: 'space-between', gap: 5 }}>
          <Skeleton
            variant='rectangular'
            sx={{ width: '100%', height: '260px', borderRadius: '20px' }}
          />
          <Skeleton
            variant='rectangular'
            sx={{ width: '100%', height: '260px', borderRadius: '20px' }}
          />
          <Skeleton
            variant='rectangular'
            sx={{ width: '100%', height: '260px', borderRadius: '20px' }}
          />
          <Skeleton
            variant='rectangular'
            sx={{ width: '100%', height: '260px', borderRadius: '20px' }}
          />
        </Box>
      ) : land ? (
        <DashboardCardPlacer
          land={land}
          rainCardInfo={rainDashboarCardInformation}
          rodeoInfo={cardInfo}
        />
      ) : (
        <DashboardNoLand />
      )}
    </Box>
  )
}

Home.acl = {
  action: 'read',
  subject: 'home-page'
}
export default Home
